module.exports = "<section class=\"list-section\">\n  <h2>{{title}}</h2>\n  <ul>\n    <li *ngFor=\"let item of request.results\" (click)=\"selectItem(item)\" >{{item.title}} {{item.name}} </li>\n  </ul>\n  <div class=\"btn-contianer\">\n    <button *ngIf=\"hasPrevPage\" id=\"previousBtn\" class=\"prev\" (click)=\"previousPage()\" > Previous </button>\n    <button *ngIf=\"hasNextPage\" id=\"nextBtn\" class=\"next\" (click)=\"nextPage()\" > Next </button>\n  </div>\n    \n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/list-view/list-view.component.html
// module id = 318
// module chunks = 2